import * as React from "react";
import { connect } from "react-redux";
import { selectIsEventRunningByEventType } from "../../selectors/selectEventInfo";
import { selectIsTournamentLevelMatched } from "../../selectors/selectTournamentInfo";
import { EventType } from "../balancing/types/BalancingCore";
import { IdTeasers } from "./IdTeasers";
import { LeagueInfo } from "./LeagueInfo";
import { TabTournamentTeaser } from "./TabTournamentTeaser";
var _TabPlayerLeague = function (_a) {
    var isPlayerLeagueRunning = _a.isPlayerLeagueRunning, canPlayerParticipate = _a.canPlayerParticipate;
    if (!canPlayerParticipate) {
        return React.createElement(TabTournamentTeaser, { type: IdTeasers.PlayerLevelTooLowPlayerLeague });
    }
    else if (isPlayerLeagueRunning) {
        return React.createElement(LeagueInfo, null);
    }
    else {
        return React.createElement(TabTournamentTeaser, { type: IdTeasers.NoPlayerLeagueRunning });
    }
};
var mapState = function (state) { return ({
    canPlayerParticipate: selectIsTournamentLevelMatched(state, EventType.PlayerLeague),
    isPlayerLeagueRunning: selectIsEventRunningByEventType(state, EventType.PlayerLeague),
}); };
export var TabPlayerLeague = connect(mapState)(_TabPlayerLeague);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TabPlayerLeague.tsx
// module id = 2795
// module chunks = 3